<template>
	<div class="container">
		<div class="footer_box">
			<div class="footer_box_main">
				<img class="logo" src="../../assets/img_h5/logo.png" @click="goHome" />
				<div class="tit_box" style="padding-top: 40px;">
					<div class="tit_el" style="width: auto;padding-right: 50px;">
						<div class="tit" @click="goHome">HOME</div>
						<div v-for="(value, index) in navList" :key="index" class="txt" @click="goNav(value)">{{ initStr(value.title) }}</div>
					</div>
					<div class="tit_el" style="flex: 1;">
						<div class="tit" @click="goNav2">PRODUCTS</div>
						<div v-for="(value, index) in productType" :key="index" class="txt" @click="goProducts(value)">{{ initStr(value.title) }}</div>
						<div class="txt" @click="goIm">I-MEMBRANE</div>
					</div>
				</div>
				<!-- <div class="tit_box">
					<div class="tit_el" style="width: auto;padding-right: 50px;">
						<div class="tit" @click="goServices">SERVICES</div>
						<div v-for="(value, index) in servicesList" :key="index" class="txt" @click="goServices">{{ initStr(value.name) }}</div>
					</div>
				</div> -->
				<div class="follow_box">
					<div class="title">FOLLOW US</div>
					<div class="link_box">
						<img v-for="(value, index) in linkList" :key="value.imgUrl" class="link_el" :src="value.imgUrl" @click="goLink(value)" />
					</div>
				</div>
				<div class="msg">Copyright {{ yearData }}, UC reagent, Inc. All rights reserved.</div>
			</div>
		</div>
	</div>
</template>

<script>
// import { submitMsg } from '@/api/public';  //提交留言
import moment from 'moment';
export default {
	components:{
		//
	},
	data() {
		return {
			linkList: [
				{ imgUrl: require('@/assets/img/footer/icon_1.webp'), link: 'https://www.linkedin.com/company/jtests/' },
				// { imgUrl: require('@/assets/img/footer/icon_2.webp'), link: '' },
				{ imgUrl: require('@/assets/img/footer/icon_3.webp'), link: 'https://x.com/JtestsBiotech' },
				{ imgUrl: require('@/assets/img/footer/icon_4.webp'), link: 'https://www.instagram.com/jtestsbiotech/' }
				// { imgUrl: require('@/assets/img/footer/icon_5.webp'), link: '' }
			],
			navList: [
				{ title: 'ABOUT', route: '/about' },
				{ title: 'NEWS', route: '/news' },
				// { title: 'CAREERS', route: '/careers' },
				{ title: 'CONTACT', route: '/contact' }
			],
			productType: [],
			servicesList: [],
			yearData: null
		}
	},
	created(){
		let that = this;
		if(sessionStorage.getItem('navData')) {
			that.productType = JSON.parse(sessionStorage.getItem('navData')).cate_list;
			that.servicesList = JSON.parse(sessionStorage.getItem('navData')).service_list;
		}
		that.yearData = moment().format('YYYY');
	},
	mounted() {
		let that = this;
	},
	methods: {
		initStr(value) {
			return value.toUpperCase();
		},
		//跳转服务
		goServices() {
			let that = this;
			// if(that.$route.path != '/services') {
			// 	that.$router.push({ path: '/services' });
			// }else {
			// 	window.location.reload();
			// }
		},
		//跳转产品
		goProducts(value) {
			let that = this;
			if(that.$route.path != '/products') {
				that.$router.push({ path: '/products', query: { type: value.id } });
			}else {
				that.$router.push({ path: '/products', query: { type: value.id } });
				window.location.reload();
			}
		},
		//导航点击
		goNav(value) {
			let that = this;
			if(value.route != '/careers') {
				if(that.$route.path != value.route) {
					that.$router.push({ path: value.route });
				}else {
					window.location.reload();
				}
			}else {
				window.location.href = 'https://cordx.com/careers';
			}
		},
		goNav2() {
			let that = this;
			if(that.$route.path != '/products') {
				that.$router.push({ path: '/products' });
			}else {
				that.$router.push({ path: '/products' });
				setTimeout(() => {
					window.location.reload();
				}, 300);
			}
		},
		goIm() {
			window.location.href = 'https://i-membrane.com/';
		},
		//跳转外链
		goLink(value) {
			if(value.link) {
				window.location.href = value.link;
			}
		},
		//点击首页
		goHome() {
			console.log(1)
			if(this.$route.path != '/') {
				this.$router.push({ path: '/' });
			}else {
				window.location.reload();
			}
		}
	}
}
</script>

<style lang="less" scoped>
.footer_box{
	font-size: 14px;
	color: #000000;
	.footer_box_main{
		padding: 50px 16px 60px 16px;
		background-color: #F6F6F6;
		.msg{
			padding-top: 30px;
			color: #999;
		}
		.follow_box{
			padding-top: 20px;
			border-top: 1px solid #CCCCCC;
			.link_box{
				padding-top: 5px;
				.link_el{
					display: inline-block;
					height: 30px;
					margin-right: 15px;
				}
			}
			.title{
				font-size: 16px;
				color: #666666;
			}
		}
		.tit_box{
			display: flex;
			.tit_el{
				padding-bottom: 20px;
				.txt{
					padding-top: 7px;
					font-size: 16px;
					color: #666666;
				}
				.tit{
					font-size: 16px;
					font-weight: bold;
				}
			}
		}
		.logo{
			// width: 100px;
			height: 30px;
		}
	}
}
</style>